const DEFAULT_DELAYS = [1_000, 2_000, 4_000, 8_000, 12_000, 12_000, 12_000];
/**
 * CLIENT_STREAM_DROPPED recovery: poll history until the assistant reply
 * ARRIVES (absence-retry), not merely until a fetch succeeds — one successful
 * fetch ~0ms post-drop returns history without the reply.
 */
export async function awaitReplyInHistory(client, conversationId, opts = {}) {
    const { afterMessageId, budgetMs = 50_000, delaysMs = DEFAULT_DELAYS, agentId } = opts;
    const started = Date.now();
    let lastMessages = [];
    let lastErr = null;
    let fetchedOnce = false;
    for (let attempt = 0;; attempt += 1) {
        try {
            const { messages } = await client.conversations.messages(conversationId, { pageSize: 100, agentId });
            lastMessages = messages ?? [];
            fetchedOnce = true;
            if (afterMessageId) {
                const replyFound = lastMessages.some((m) => m.senderType === 'SENDER_TYPE_AGENT' && m.id > afterMessageId);
                if (replyFound)
                    return { messages: lastMessages, replyFound: true };
                // reply absent — keep polling within budget
            }
            else {
                // no anchor: best-effort single fetch
                return { messages: lastMessages, replyFound: false };
            }
        }
        catch (err) {
            lastErr = err;
        }
        const delay = delaysMs[Math.min(attempt, delaysMs.length - 1)] ?? 12_000;
        if (Date.now() - started + delay > budgetMs)
            break;
        await new Promise((r) => setTimeout(r, delay));
    }
    if (!fetchedOnce && lastErr)
        throw lastErr;
    return { messages: lastMessages, replyFound: false };
}
//# sourceMappingURL=recovery.js.map